import React from 'react';
import SimpleProductPage from './SimpleProductPage';
import { screensData } from '../../data/screensData';

const GarminEchomapUltra2126sv = () => {
  // Get the product data directly from screensData
  const productId = "echomap-ultra-2-126sv";
  const productData = screensData.find(item => item.id === productId);
  
  console.log('GarminEchomapUltra2126sv - Direct Import - Product Data:', productData);
  console.log('GarminEchomapUltra2126sv - Direct Import - Image URL:', productData?.image);
  
  // Use a direct image URL if we can't find one
  const imageUrl = productData?.image || "https://www.buildmyfishfinder.com/images/screens/garmin-echomap-ultra2-126sv.jpg";
  
  return (
    <SimpleProductPage 
      specificProductId="echomap-ultra-2-126sv"
      productName="Garmin ECHOMAP Ultra 2 126sv"
      productImage={imageUrl}
      csvLookupId="Echomap Ultra 2 126sv"
    />
  );
};

export default GarminEchomapUltra2126sv; 